const STAGE_PROGRESS: Record<string, number> = {
  pending: 0,
  in_progress: 50,
  processing: 50,
  on_hold: 50,
  completed: 100,
  closed: 100,
  archived: 100,
  cancelled: 0,
};

/**
 * Cheap stage-based progress estimate from a case's status alone.
 * Use in list/table contexts where per-row activity-log queries would be expensive.
 */
export const getCaseProgressFromStatus = (status?: string | null): number => {
  const key = (status || 'pending').toLowerCase();
  return STAGE_PROGRESS[key] ?? 0;
};

/**
 * Accurate progress from the ratio of completed activity logs, falling back to the
 * stage-based estimate when the case has no logs yet. Use on the case detail page,
 * where logs are already fetched for the single case being viewed.
 */
export const getCaseProgressFromLogs = (
  logs: Array<{ status?: string | null }> | undefined,
  status?: string | null,
): number => {
  if (!logs || logs.length === 0) {
    return getCaseProgressFromStatus(status);
  }
  const completed = logs.filter((log) => (log.status || 'pending').toLowerCase() === 'completed').length;
  return Math.round((completed / logs.length) * 100);
};
